import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';
import Img01 from "../../images/services/dm/Marketplace-fees.webp";
import Img02 from "../../images/services/dm/Mobile-optimization.webp";
import Img03 from "../../images/services/dm/Product-reviews.webp";
import Img04 from "../../images/services/dm/Secure-payments.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Servicespartner(props) {
    return (
        <div className="tekrevol_gray_bg p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                        <div className="example" data-text="Solutions">
                            <h2>Partner With TekRevol For Exemplary Digital Marketplace Solutions</h2>
                        </div>
                        <h5 className="strong">What makes us the best digital marketplace development company in the
                            region?</h5>
                        <p>It’s our mission to create an impact in the world through technology products, solutions, and
                            services. We combine people, processes, and technological advancements to help organizations
                            experience real innovation. This way, our partner clients have produced game-changing
                            results and yielded high business performance.</p>
                         <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-lg-5 offset-lg-1">
                        <Row>
                            <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                                <div className="set_of_images hover01">
                                    <LazyLoadImage
                                        src={Img01}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Marketplace Fees</p>
                                </div>
                                <div className="set_of_images hover01 mt-4">
                                    <LazyLoadImage
                                        src={Img03}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Product Reviews</p>
                                </div>
                            </Col>
                            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-lg-4 mt-md-0">
                                <div className="set_of_images hover01">
                                    <LazyLoadImage
                                        src={Img02}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Mobile Optimization</p>
                                </div>
                                <div className="set_of_images hover01  mt-4">
                                    <LazyLoadImage
                                        src={Img04}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Secure Payments</p>
                                </div>
                            </Col>
                        </Row>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Servicespartner;